import { Button, Tag, Switch } from 'antd';
import { MdEdit, MdDelete } from 'react-icons/md';
import { IProduct } from '../../../types/productSetup';

interface ProductCardProps {
  product: IProduct;
  onUpdate: (product: IProduct) => void;
  onDelete: (productId: string) => void;
  onToggleActive?: (productId: string, statuscode: number) => void;
}

export const ProductCard = ({ product, onUpdate, onDelete, onToggleActive }: ProductCardProps) => {
  return (
    <div className="border border-neutral-400 rounded-lg p-4  bg-white relative">
      <div className="flex items-start gap-3">
        {/* Icon/Image */}
        <div className="">
          <div className=" h-full flex flex-1 items-center justify-center">
            {/* <span className="text-3xl">📦</span> */}
            {product.dogma_productimageurl ? <img src={product.dogma_productimageurl} className='w-24 h-24 object-contain' /> : <div className='w-24 h-24 bg-gray-200'></div>}
          </div>
        </div>

        {/* Content */}
        <div className="flex-1 min-w-0">
          {/* Title and Product Number */}
          <h3 className="text-lg font-semibold text-text-primary">
            {product.name}
          </h3>
          {product.productnumber && (
            <p className="text-xs text-text-secondary mb-2">
              #{product.productnumber}
            </p>
          )}
          {product.description && (
            <p className="text-sm text-text-secondary mb-3">
              {product.description}
            </p>
          )}

          {/* Pricing Information */}
          <div className="flex items-start gap-6 mb-3 flex-wrap">
            {product.price !== undefined && (
              <div>
                <p className="text-sm text-text-secondary mb-0.5">Base Price</p>
                <p className="text-lg font-bold text-text-primary">
                  £{product.price}
                </p>
              </div>
            )}
            {product.dogma_unglazedprice !== undefined && (
              <div>
                <p className="text-sm text-text-secondary mb-0.5">Unglazed Price</p>
                <p className="text-lg font-bold text-amber-600">
                  £{product.dogma_unglazedprice}
                </p>
              </div>
            )}
          </div>

          {/* Status Badge */}
          <div className="flex items-center gap-2 flex-wrap">
            <Tag
              className={`m-0 ${product.statuscode === 1
                  ? 'bg-green-500 text-white border-green-500'
                  : 'bg-gray-200 text-gray-600 border-gray-200'
                }`}
            >
              {product.statuscode === 1 ? 'Active' : 'Inactive'}
            </Tag>
          </div>
        </div>

        {/* Actions */}
        <div className="flex flex-col gap-3 items-end">
          {onToggleActive && (
            <Switch
              checked={product.statecode === 0}
              onChange={(checked) => onToggleActive(product.productid, checked ? 0 : 1)}
              size={"default"}
            />
          )}
          <Button
            type="text"
            size="middle"
            variant='solid'
            icon={<MdEdit size={20} />}
            className="text-primary hover:bg-primary-50"
            onClick={() => onUpdate(product)}
          />
          <Button
            type="text"
            size="middle"
            icon={<MdDelete size={20} />}
            className="text-red-500 hover:text-red-600 hover:bg-red-50"
            onClick={() => onDelete(product.productid)}
          />
        </div>
      </div>
    </div>
  );
};
